import ContentManagementModule from './config';
import { contentManagement as contentManagementReducer } from './reducer';

export { contentManagementReducer };
export default ContentManagementModule;
